import { lazy } from "react";

const TreatzSpa = lazy(() => import("@src/pages/treatzSpa"));

export const treatzSpaRoutes = [{ path: "/treatz-spa", element: <TreatzSpa /> }];
